import { TUseMutationOptions } from '../query/type'
import { usePostThirdAccountLoginMutation } from '../query/yapi/hk-web/ThirdAccount/query'
import { TPostThirdAccountLoginResponse, TPostThirdAccountLoginParams } from '../service/yapi/hk-web/ThirdAccount/api'

type TThirdParty = 'google' | 'apple' | 'telegram'

// 处理第三方登录提交逻辑
export default function useCommitThirdPartyLogin(
  mutationOptions?: TUseMutationOptions<TPostThirdAccountLoginResponse, TPostThirdAccountLoginParams>
) {
  const { mutate: commitLogin } = usePostThirdAccountLoginMutation(mutationOptions)
  const commitThirdPartyLogin = (thirdParty: TThirdParty, channel: string, data) => {
    const params = {
      verify: true,
      accountType: thirdParty,
      channel,
      idToken: '',
      authorizationCode: '',
    }
    switch (thirdParty) {
      case 'google':
        params.idToken = data.credential
        break
      case 'telegram':
        params.idToken = JSON.stringify(data)
        break
      case 'apple':
        params.idToken = data.authorization.id_token
        params.authorizationCode = data.authorization.code
        break
    }

    commitLogin(params)
  }
  return commitThirdPartyLogin
}
